import { transformSeries } from '../utils';
import createPointFormatter from './pointFormatter';

function getVisitOption(primaryChart) {
  return {
    chart: {
      type: 'column',
    },
    tooltip: {
      headerFormat: '<strong>{point.x}</strong><br/>',
      pointFormatter: createPointFormatter(primaryChart),
      shared: false,
    },
    plotOptions: {
      column: {
        stacking: 'normal',
      },
    },
  };
}
export default function transformVisitChart({ primaryChart }) {
  const options = getVisitOption(primaryChart);
  const transformedSeries = transformSeries(primaryChart);
  return { options, series: transformedSeries };
}
